import { FlexRow, Button } from "@utdanningsdirektoratet/lisa";
import { breakpoints, tabFocus } from "@utdanningsdirektoratet/lisa-tokens";
import React from "react";
import styled from "styled-components";
import UtdanningsdirektoratetSort from "assets/elev/UtdanningsdirektoratetSort.svg?react";
import { SvgContainer } from "./SvgContainer";
import TEXT from "../../errors/TEXT";

interface HeaderProps {
	hideLogoutButton?: boolean;
	className?: string;
}

export const Header: React.FunctionComponent<HeaderProps> = (props: HeaderProps) => {
	return (
		<HeaderContainer className={props.className}>
			<FlexRow halign="space-between">
				<UdirLogoLink href="/" title={TEXT.tilbakeTilElevUdirNo}>
					<UdirLogoContainer>
						<UtdanningsdirektoratetSort />
					</UdirLogoContainer>
				</UdirLogoLink>
				{props.hideLogoutButton ? null : (
					<Button
						variant="outlined"
						onClick={() => {
							window.location.href = "/Account/LogOff";
						}}
					>
						{TEXT.loggUt}
					</Button>
				)}
			</FlexRow>
		</HeaderContainer>
	);
};

// TODO: Gå over stylingen i hele elev-appen, den er veldig spesifikk
const HeaderContainer = styled.header`
	padding: 44px 80px 0 80px;
	margin-bottom: 56px;

	@media (max-width: ${breakpoints.px.small}) {
		padding: 36px 24px 0 24px;
	}
`;

const UdirLogoContainer = styled(SvgContainer)`
	width: 153px;
`;

const UdirLogoLink = styled.a`
	${tabFocus()}
`;
